import platform from '@propertypal/shared/src/utils/platform';
import ContactForm from '@propertypal/web-ui/src/contact/ContactForm';
import ContactHeader from '@propertypal/web-ui/src/headers/contact/ContactHeader';
import Head from 'next/head';
import React from 'react';
import generateMetaTags from '../components/layout/MetaTags';

const metaData = {
  title: `Contact Details - ${platform.title}`,
  // eslint-disable-next-line max-len
  description: `Find Out When and How to Contact ${platform.title} Including Details On Our Technical Support Offering, Telephone Number and Email Address.`,
  url: `/contact`,
};

const formOptions = {
  who: [
    {
      value: 'public',
      label: 'Member of the public',
    },
    {
      value: 'agent',
      label: 'Estate Agent',
    },
    {
      value: 'developer',
      label: 'Developer',
    },
    {
      value: 'press',
      label: 'Press Agency',
    },
    {
      value: 'other',
      label: 'Other',
    },
  ],
  publicQuery: [
    {
      value: 'enquireProperty',
      label: 'I want to enquire about a property',
    },
    {
      value: 'reportProblem',
      label: 'I want to report a problem',
    },
    {
      value: 'feedback',
      label: 'I want to give feedback',
    },
    {
      value: 'other',
      label: 'Other',
    },
  ],
  agentQuery: [
    {
      value: 'support',
      label: 'I need technical support',
    },
    {
      value: 'list',
      label: `I want to list my properties on ${platform.title}.com`,
    },
    {
      value: 'website',
      label: 'I want a new website built for my company',
    },
    {
      value: 'agentOther',
      label: 'Other',
    },
  ],
  devQuery: [
    {
      value: 'devSupport',
      label: 'I need technical support',
    },
    {
      value: 'devlList',
      label: `I want to list my properties on ${platform.title}.com`,
    },
    {
      value: 'devWebsite',
      label: 'I want a new website built for my company',
    },
    {
      value: 'devOther',
      label: 'Other',
    },
  ],
};

const ContactPage = () => {
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>

      <ContactHeader />
      <ContactForm options={formOptions} />
    </>
  );
};

export default ContactPage;
